export default __webpack_public_path__ + "static/media/PermissionsImage.15384894.svg";